<mat-toolbar color="primary">
  <mat-toolbar-row class="container">
    <span>{{ 'components.responses.view_questionnaire_response' | translate}}</span>
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" (click)="!loading ? closeDialogue() : ''"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

<div class="container my-5">
  <app-survey-response-page [surveyID]="data?.surveyID" [impersonateEmail]="data.impersonateEmail"/>
</div>
